<template>
    <div>
      <!-- Space -->
      <div class="space-web visible-lg visible-md"></div>
      <div class="space-mobil visible-xs visible-sm"></div>

      <!-- Buscador Movil -->
      <div class="container">
          <div class="row">
              <div class="col-sm-12">
                  <div class="busqueda-contenido2 visible-sm visible-xs">

                      <form role="form" @submit.prevent="generalSearch" method="get" >
                        <ul class="list-inline">
                          <li style="width: 77%;"><input v-model="simpleSearchInput" autocomplete="off" class="form-control"  @keyup="getList"  placeholder="Buscar en Who's Who..."></li>
                          <li style="width: 10%;"><a  @click.prevent="generalSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                          <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada2"><i class="fa fa-plus"></i></button></li>
                        </ul>
                        <div class="autocomplete" v-show="isOpen" >
                          <ul class="autocomplete-results">
                              <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                {{ result.nameRecord }}
                              </li>
                          </ul>
                </div>
                      <div class="radio-ww animated slideInRight visible-sm visible-xs">
                           <label class="radio-inline">
                             <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="ww">Who's Who
                            </label>
                            <!-- <label class="radio-inline">
                              <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="guia">OTT
                           </label> -->
                       </div> 
                      </form>

                  </div>
                  <div class="busq-avanzada">
                      <div id="busqavanzada2" class="collapse">
                          <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                              <div class="form-group">
                                <div class="col-sm-12">
                                  <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-sm-12">
                                  <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-sm-12">
                                  <select class="form-control" name="country" v-model="countryIn"  >
                                  <option :value="0" selected >-- País --</option>
                                  <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                  </select>
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-sm-12">
                                  <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                  <option  :value="0"  selected >-- Categoría --</option>
                                  <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                  </select>
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-sm-12">
                                  <select class="form-control" name="activity" v-model="activityIn" >
                                  <option  :value="0"  selected >-- Actividad --</option>
                                  <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                  </select>
                                </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!-- Banner Horizontal -->
      <div class="banner visible-lg visible-md animated slideInDown">
          <div class="container" v-if="contactCompanies[0]">
            <div id="sas_31458" >
           <script2>{{contactCompanies[0].WWonlineBannerTopFM}}</script2>
            </div>
          </div>
      </div>

      <!-- Contenido -->
      <div class="contenido-resultados" >
          <div class="container">
              <div class="row">
                 <div class="col-md-8">
                      <!-- Ficha Persona -->
                      <div class="contacto-persona animated slideInLeft">
                          <div class="row">
                              <div class="col-md-4" align="center">
                                  <div class="imagen-persona-contacto">
                                      <a href=""><div class="feat-image" v-if="contact.Images && contact.Images !== null" :style="{ 'background-image': 'url(\'https://images.produ.com/ww/'+ getVerticalContact(contact.Images) + '\')' }"  ></div></a>
                                  </div>
                              </div>
                              <div class="col-md-8 info-resultado">
                                  <router-link :to="'/contacto/'+contact.permalink_contacto" >
                                        <h1 v-if="(typeof contact.LastName !== 'undefined' )"  v-html="contact.FirstName+' '+contact.LastName" ></h1>
                                  </router-link>
                                  <h2 v-html="contact.Title" v-if="(typeof contact.Title !== 'undefined' )"  ></h2>

                                  <router-link :to="'/empresa/'+contact.permalink_empresa" >
                                    <h3  v-html="contact.CompanyName" ></h3>
                                  </router-link>
                                  <p v-html="contact.NombreCategory" v-if="(typeof contact.NombreActivity !== 'undefined' )" ></p>
                                  <p v-html="contact.CargoAdicional" v-if="(typeof contact.CargoAdicional !== 'undefined' )" ></p>
                                  <p v-html="contact.DireccionAdicional" v-if="(typeof contact.DireccionAdicional !== 'undefined' )" ></p>
                                  <div class="icons-contacto">
                                      <!-- <ul class="list-inline">
                                          <li><a href="" data-toggle="modal" data-target="#ModalContacto"><i class="fa fa-envelope"></i></a> </li>
                                          <li>
                                            <a v-if="contact.Phone1" :href="'tel:'+contact.Phone1" ><i class="fa fa-phone"></i></a>
                                          </li>

                                          <li><a href="" data-toggle="modal" data-target="#ModalCompartir"><i class="fa fa-share-alt visible-xs visible-sm"></i></a> </li>
                                          <div class="share-new pull-right visible-lg visible-md" style="color:#000000;font-weight: bold;">
                                              <li ><i class="fa fa-share-alt"></i></li>
                                              <div class="share-buble">
                                                  <p><a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://www.facebook.com/sharer/sharer.php?u=http://who.produ.com/contacto/'+contact.permalink_contacto" class="facebook"><i class="fa fa-facebook" aria-hidden="true" style="font-size: 15px;"></i><span>Facebook</span></a></p>
                                                  <p><a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://twitter.com/intent/tweet?status='+contact.FirstName+' '+contact.LastName+'http://who.produ.com/contacto/'+contact.permalink_contacto+'&title='+contact.FirstName+' '+contact.LastName"  class="twitter"><i class="fa fa-twitter" aria-hidden="true" style="font-size: 15px;"></i><span>Twitter</span></a></p>
                                                  <p><a  onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://www.linkedin.com/shareArticle?mini=true&url=http://who.produ.com/contacto/'+contact.permalink_contacto+'&title='+contact.FirstName+' '+contact.LastName+'&source=http://who.produ.com'" class="whatsapp"><i class="fa fa-whatsapp" aria-hidden="true" style="font-size: 15px;"></i><span>Whatsapp</span></a></p>
                                                  <!--<p><a href="#" class="g-plus"><i class="fa fa-google" aria-hidden="true" style="font-size: 15px;"></i><span>Gmail</span></a></p>-->

                                                  <!--<p><a   class="pinterest"><i class="fa fa-pinterest" aria-hidden="true"></i><span>Pinterest</span></a></p>
                                                  <p><a class="g-plus"><i class="fa fa-google-plus" aria-hidden="true"></i><span>Google+</span></a></p>-->

                                            <!--  </div>
                                          </div>
                                      </ul> -->
                                  </div>
                              </div>
                          </div>
                      </div>
                      <!-- Noticias , English y Videos-->
                      <app-content></app-content>

                 </div>
                 <div class="col-md-4 animated slideInRight">
                      <!-- Busqueda Web -->
                   <form class="visible-lg visible-md" @submit.prevent="generalSearch" method="get" > 
                      <div class="busqueda-contenido visible-lg visible-md">
                          <ul class="list-inline">
                              <li style="width: 77%;"><input v-model="simpleSearchInput" autocomplete="off" class="form-control"  @keyup="getList"  placeholder="Buscar en Who's Who..."></li>
                              <li style="width: 10%;"><a  @click.prevent="generalSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                              <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada"><i class="fa fa-plus"></i></button></li>
                          </ul>
                           <div class="autocomplete" v-show="isOpen" >
                                <ul class="autocomplete-results">
                                    <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                      {{ result.nameRecord }}
                                    </li>
                                </ul>
                           </div>
                          <div class="radio-ww animated slideInRight">
                              <label class="radio-inline">
                                  <input type="radio" v-model="selectedSearchIn" v-on:change="getList"   value="ww">Who's Who
                                </label>
                                <!-- <label class="radio-inline">
                                  <input type="radio" v-model="selectedSearchIn" v-on:change="getList"   value="guia">OTT
                              </label> -->
                         </div>
                      </div>
                     </form> 
                      <!-- Busqueda Avanzada Web -->
                      <div class="busq-avanzada">
                          <div id="busqavanzada" class="collapse">
                              <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                  <div class="form-group">
                                      <div class="col-sm-12">
                                        <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                      </div>
                                      </div>
                                      <div class="form-group">
                                      <div class="col-sm-12">
                                        <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                      </div>
                                      </div>
                                      <div class="form-group">
                                      <div class="col-sm-12">
                                        <select class="form-control" name="country" v-model="countryIn"  >
                                        <option :value="0" selected >-- País --</option>
                                        <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                        </select>
                                      </div>
                                      </div>
                                      <div class="form-group">
                                      <div class="col-sm-12">
                                        <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                        <option  :value="0"  selected >-- Categoría --</option>
                                        <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                        </select>
                                      </div>
                                      </div>
                                      <div class="form-group">
                                      <div class="col-sm-12">
                                        <select class="form-control" name="activity" v-model="activityIn" >
                                        <option  :value="0"  selected >-- Actividad --</option>
                                        <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                        </select>
                                      </div>
                                  </div>
                              </form>
                          </div>
                      </div>
                      <div class="banner" v-if="contactCompanies[0]">
                        <div id="sas_31459">
                         <script2>{{contactCompanies[0].WWonlineBannerLat1FM}}</script2>
                          </div>
                      </div>
                      <!-- Empresas -->
                      <div class="empresa"  v-if="contactCompanies[0] && (typeof contactCompanies !== 'undefined' ) ">
                          <h1>EMPRESA</h1>
                          <hr>
                          <div class="scroll-empresa">
                              <div class="lista-empresa">
                                  <router-link :to="'/empresa/'+contactCompanies[0].permalink" >
                                  <h2  v-html="contactCompanies[0].CompanyName" ></h2>
                                </router-link>
                                <p v-html="contactCompanies[0].Address1" ></p>

                                <p v-if="contactCompanies[0].Telefono1 != ''">Tel: {{ contactCompanies[0].CodAreaT1+' '+contactCompanies[0].Telefono1 | addPlusSign }}</p>
                                <p v-if="contactCompanies[0].Fax1 != ''">Fax: {{ contactCompanies[0].CodAreaF1+' '+contactCompanies[0].Fax1 | addPlusSign }}</p>
                                <p><strong v-html="contactCompanies[0].Email"  ></strong></p>
                                <a :href="'http://'+contactCompanies[0].URL.replace('https://','').replace('http://','')" target="_blank"><p class="urlSite"><strong>Visitar página web</strong></p></a>
                            </div>
                            <hr>
                          </div>
                          <br>
                          <!-- Empresas Relacionadas -->
                          <h1 v-if="contactCompanies && contactCompanies.length > 1" >EMPRESAS RELACIONADAS</h1>
                          <hr>
                          <div class="scroll-empresa" v-if="contactCompanies && contactCompanies.length > 1">
                              <template v-for="(tmp,key) in contactCompanies" v-if="key > 0 && contactCompanies">
                                <div class="lista-empresa-relacionada">
                                  <router-link :to="'/empresa/'+tmp.permalink" >
                                    <h2 v-html="tmp.CompanyName" ></h2>
                                  </router-link>
                                  <p v-html="tmp.Address1" > </p>
                                  <p  >Tel: {{ tmp.CodAreaT1+' '+tmp.Telefono1 | addPlusSign }}</p>
                                  <p >Fax: {{ tmp.CodAreaF1+' '+ tmp.Fax1 | addPlusSign }}</p>
                                  <a :href="tmp.URL"><p><strong v-html="tmp.URL" ></strong></p></a>
                                </div>
                                <hr>
                              </template>
                          </div>
                      </div>
                      <!-- Ejecutivos -->
                      <div class="ejecutivo">
                          <h1>EJECUTIVOS</h1>
                          <hr>
                          <div class="scroll-empresa">
                              <template v-for="tmp in contacts" v-if="contacts && tmp">
                                  <div class="lista-ejecutivos">

                                    <router-link :to="'/contacto/'+tmp.permalink" >
                                      <h2 v-html="tmp.nameRecord" style="text-align: left !important"></h2>
                                    </router-link>
                                    <p v-html="tmp.Title"></p>
                                  </div>
                                  <hr>
                              </template>
                          </div>
                      </div>
                 </div>
              </div>
          </div>
      </div>

      <!-- Modal Contacto -->
      <div class="modal  fade" id="ModalContacto" role="dialog">
          <div class="modal-dialog contacto">
              <div class="modal-content">
                  <div class="modal-header" align="center">
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                      <h4 class="modal-title">Contactar</h4>
                      <p>Envia un mensaje personalizado al contacto</p>
                  </div>
                  <div class="modal-body" align="center">
                      <div align="left">
                          <div class="row">
                          <div class="col-sm-1"></div>
                          <div class="col-sm-10">
                              <h5><strong>Destinatario:</strong> {{  contact.FirstName+' '+contact.LastName }}</h5>
                          </div>
                          <div class="col-sm-1"></div>
                          </div>
                      </div>
                      <hr>
                      <form class="form-horizontal" @submit.prevent="sendEmailContactWW"  method="post" >
                          <div class="form-group">
                              <div class="col-sm-1"></div>
                              <div class="col-sm-10">
                                  <input  type="text" class="form-control " :class="contactoEmailErrorMsg ? 'error_form' : ''" v-model="contactoEmail"  placeholder="Remitente (email)" />
                              </div>
                              <div class="col-sm-1"></div>
                          </div>

                          <div class="form-group">
                              <div class="col-sm-1"></div>
                              <div class="col-sm-10">
                                  <input  type="text" class="form-control" :class="contactoNameErrorMsg ? 'error_form' : ''" v-model="contactoTitle"  placeholder="Título" />
                              </div>
                              <div class="col-sm-1"></div>
                          </div>

                          <div class="form-group">
                              <div class="col-sm-1"></div>
                              <div class="col-sm-10">
                                  <textarea class="form-control" :class="contactMsgErrorMsg ? 'error_form' : ''"   rows="6" id="comment" v-model="contactMsg"  placeholder="Escribe tu comentario..." ></textarea>
                              </div>
                              <div class="col-sm-1"></div>
                          </div>

                          <div class="form-group" v-if="emailSent">
                             <div class="alert alert-success col-sm-12" role="alert">
                                  Email Enviado!
                             </div>
                          </div>

                          <div class="form-group">
                              <div class="col-sm-1"></div>
                              <div class="col-sm-10" align="center">
                                  <button @click.prevent="sendEmailContactWW" type="button" class="btn " >ENVIAR MENSAJE</button>
                              </div>
                              <div class="col-sm-1"></div>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer" align="center">
                      <h6>Visita PRODU.COM</h6>
                      <div class="row">
                          <i class="fa fa-facebook"></i>
                          <i class="fa fa-twitter"></i>
                          <i class="fa fa-google"></i>
                          <i class="fa fa-linkedin"></i>
                          <i class="fa fa-youtube"></i>
                      </div>
                  </div>
              </div>
          </div>
      </div>

  <!-- Modal Compartir -->
    <div class="modal  fade" id="ModalCompartir" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header" align="center">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Compartir</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="12">
                            <div class="redes-modal-compartir">
                                <a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://www.facebook.com/sharer/sharer.php?u=http://who.produ.com/contacto/'+contact.IdContactFM"  data-dismiss="modal" ><h5><i class="fa fa-facebook"></i>Facebook</h5></a>
                            </div>
                            <hr>
                            <div class="redes-modal-compartir">
                               <a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://twitter.com/intent/tweet?status='+contact.FirstName+' '+contact.LastName+'http://who.produ.com/contacto/'+contact.IdContactFM+'&title='+contact.FirstName+' '+contact.LastName"  class="twitter"  data-dismiss="modal" ><h5><i class="fa fa-twitter"></i>Twitter</h5></a>
                            </div>
                            <hr>
                            <div class="redes-modal-compartir">
                                 <a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'https://api.whatsapp.com/send?text=' +contact.FirstName + ' ' + contact.LastName + ' ' + 'http://who.produ.com/contacto/'+contact.IdContactFM"  class="whatsapp show-for-small-only icon-whatsapp"  data-dismiss="modal"><h5><i class="fa fa-whatsapp" target="_blank"></i>Whatsapp</h5></a>
                            </div>
                            <hr>
                            <div class="redes-modal-compartir lastItem" > 
                                 <a href="" data-toggle="modal" data-target="#ModalContacto"  data-dismiss="modal" ><h5><i class="fa fa-google"></i>Gmail</h5></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

      <!-- Modal Cerrar Sesión -->
      <div class="modal  fade" id="ModalCerrarSesion" role="dialog">
          <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header" align="center">
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                      <h4 class="modal-title">Cerrar Sesión</h4>
                  </div>
                  <div class="modal-body" align="center">
                      <p>¿Seguro que deseas Cerrar Sesión?</p>
                      <div class="row">
                          <div class="col-sm-2"></div>
                          <div class="col-sm-8">
                              <button class="btn_aceptar close"  data-dismiss="modal">Aceptar</button>
                              <button class="btn_cancelar close"  data-dismiss="modal">Cancelar</button>
                          </div>
                          <div class="col-sm-2"></div>
                      </div>
                  </div>
                  <div class="modal-footer" align="center">
                      <h6>Visita PRODU.COM</h6>
                      <div class="row">
                          <i class="fa fa-facebook"></i>
                          <i class="fa fa-twitter"></i>
                          <i class="fa fa-google"></i>
                          <i class="fa fa-linkedin"></i>
                          <i class="fa fa-youtube"></i>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>


<script>
var resfulApi="https://backend.produ.com/admin/index.php/welcome/"
//var resfulApi="http://produbackend/admin/index.php/welcome/"
import axios from 'axios'

import Content from './contact/Content.vue'
import '../assets/css/contacto.css'

export default {
  name: 'Contacto',
  components : {
   'app-content': Content
  },
  data () {
    return {
        resultSearch: [],
        AdvanceSearchInput: '',
        simpleSearchInput: '',
        countries:[],
        categories: [],
        activities: [],
        categoryIn: 0,
        contactoIn: '',
        empresaIn: '',
        countryIn: 0,
        activityIn: 0,
        contactID: 0,
        contact:[],
        contactCompanies:[],
        contacts: [],
        isMobile:false,
        contactoName:'',
        contactoEmail:'',
        contactMsg:'',
        contactoTitle: '',
        contactoNameErrorMsg:false,
        contactoEmailErrorMsg:false,
        contactMsgErrorMsg:false,
        contactoTitleErrorMsg: false,
        emailSent: false,
        metaTitle: '',
        metaDescr: '',
        metaUrl: '',
        metaImg: '',
        errors:[],
        selectedSearchIn: 'ww',
        isOpen: false,
        auxSearch:{},
        contactos: [],
        nombres:'',
        permalink : 0,
    }
  },
  metaInfo () {

    return {
      title: this.metaTitle,
      meta: [{   property: "og:url", content: this.metaUrl}],
      meta: [{   property: "og:type", content: "website"}],
      meta: [{   name: "author", content: "PRODU"}],
      meta: [{   name: "description", content: this.metaDescr}],
      meta: [{   name: "copyright", content: "PRODU"}],
      meta: [{   property: "og:title", content: this.metaTitle}],
      meta: [{   property: "og:image", content: this.metaImg}],

    }
  },
  created () {
  },
  methods: {
    moment: function () {
      return moment()
    },
    getContact: async function(contacID){
        this.contactID=contacID

        await axios.post(resfulApi+'getContactWWFWS', {
            token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
            contantIN: this.contactID
          }).then((response)  =>  {
            this.contact =response.data.contact
            this.contactCompanies =response.data.companies.data
            this.contacts =response.data.companies.contacts
            this.metaTitle = this.contact.FirstName+' '+this.contact.LastName
            this.metaDescr = this.contact.FirstName+' '+this.contact.LastName
            this.metaUrl = "http://who.produ.com/contacto/"+this.contact.IdContactFM
            this.metaImg = 'https://images.produ.com/ww/'+ this.getVerticalContact(this.contact.Images)

            this.$nextTick(function(){

            })
        })

    },
    getActivity: async function(){
      if(this.categoryIn){

         await axios.post(resfulApi+'getActivitiesByCategoryWWFWS', {
            token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
            category: this.categoryIn
          }).then((response)  =>  {
            this.activities =response.data

            this.$nextTick(function(){

            })
        })
      }

    },
    getDataForm: async function(){

      await axios.post(resfulApi+'getCountriesWWFWS', {
          token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@"
        }).then((response)  =>  {
          this.countries =response.data.countries
          this.categories = response.data.categories

          this.$nextTick(function(){

          })
      })

      this.getActivity()
    },
    advanceSearch: async function(page) {
      this.currentPage=page
      this.$router.push('/advancesearch/'+this.contactoIn+'_'+this.empresaIn+'_'+this.countryIn+'_'+this.categoryIn+'_'+this.activityIn)
    },
    contactSearch:function(e) {
      if(this.simpleSearchInput){

        this.$router.push('/busqueda/'+this.simpleSearchInput)
      }
    },
    getDataClick: async function(newVal){
        this.contactID = newVal
        this.$route.params.contacto=this.contactID
        this.getContact(newVal)
    },
    sendEmailContactWW : async function(e) {
        this.errors = []
        this.contactoNameErrorMsg = false
        this.contactMsgErrorMsg = false
        this.contactoEmailErrorMsg = false


        if(!this.contactoTitle){
            this.contactoNameErrorMsg = true
            this.errors.push("Titulo requerido.");
        }
        if(!this.contactMsg){
            this.contactMsgErrorMsg = true
            this.errors.push("Mensage requerido.");
        }

        if(!this.contactoEmail || !this.validEmail(this.contactoEmail)) {
            this.contactoEmailErrorMsg = true
            this.errors.push("Valid Email required.");
        }

        if(this.contact && this.errors.length == 0 ){
            await axios.post(resfulApi+'sendEmailContactWW', {
                token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
                email: this.contactoEmail,
                title: this.contactoTitle,
                msg: this.contactMsg,
                emailD: this.contact.Email
              }).then((response)  =>  {

                this.emailSent = (parseInt(response.data) == 1);
                this.$nextTick(function(){

                })
            })

        }

    },
    simpleSearch:function(e) {
       if(this.simpleSearchInput && this.isActiveSearch()){
        this.nombres= (this.nombres=='') ? this.simpleSearchInput : this.nombres
         this.$router.push({
            name: 'Search', 
            params: { permalink: this.permalink,tipo : this.selectedSearchIn ,search: this.simpleSearchInput,nombres : this.nombres }
         })
      }
    },
    generalSearch:function(e) {
       if(this.simpleSearchInput && this.isActiveSearch()){
         this.nombres= this.simpleSearchInput 
         this.$router.push({
            name: 'Search', 
            params: { permalink: 0,tipo : this.selectedSearchIn ,search: this.simpleSearchInput,nombres : this.nombres }
         })
      }
    },
    isActiveSearch(){
    return  ((!this.selectedSearchIn || this.simpleSearchInput.length<=0)? false : true)
    },
     getList : function(){     
      (this.simpleSearchInput.length > 3) ? this.getSearchWWFWS() :  this.isOpen=false
    },
    getSearchWWFWS: async function(){
       await axios.post(resfulApi+'getSearchWWFWS', {
          token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
          search: this.simpleSearchInput,
          tipo: this.selectedSearchIn
        }).then((response)  =>  {
          this.contactos =response.data;
          (this.contactos.length > 0) ? this.isOpen=true : this.isOpen=false
             
      })
    },
    setResult : async function(result){
       this.simpleSearchInput = result.nombres
       this.permalink = result.permalink
       this.nombres=result.nombres
       this.isOpen=false
       var typeSearch = this.redirectConsulta(result.nameRecord,result.GuiaOTT)
       this.$router.push('/'+typeSearch+'/'+result.permalink)

    },
  },
  beforeMount() {

  },
  mounted: function () {
      this.contactID=this.$route.params.contacto

      this.isMobile = this.checkMobile()

      this.getContact(this.contactID)
      this.getDataForm()
  },
  watch: {
      '$route.params.contacto'(newId, oldId) {
          this.contactID=newId
          this.getContact(this.contactID)
      }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .filtro-negro a:hover{
     cursor: pointer;
  }

  a:hover{
      cursor:pointer;
  }

  .ficha{
      overflow: inherit !important;
  }


  .blog .ficha .blog-content h3 {
    line-height: 1.2 !important;
}


    .contact-header{
         margin-top: 20px;
    }

    .contact-share-icons{
        text-align: right;
        padding-right: 20px;
    }

    .urlSite{
      color: #016e8f;
    }

  @media only screen and (max-width: 650px) {
      .blog-content h1, a, h4 {
          text-align: center !important;
      }

      .contact-share-icons{
          text-align: center;
          padding-right: 0px;
      }


      .contact-header{
           margin-top: -40px;
           padding-top: 20px;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/Contacto.vue